import React from 'react'

import { ActionsBar, Button, Loading, Modal, Text } from '@fielded/shared-ui'

const PackDeliveryModal = ({
  isOpen,
  onClose,
  onConfirm,
  loading
}) => {
  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      title='Irreversible action'
      centered={false}
    >
      {loading ? (
        <Loading spread loadingText='Packing shipments...' />
      ) : (
        <div className='vs-u-column-spaced'>
          <Text className='vs-u-margin-bottom'>
            You are about to change the status of the selected <b>scheduled</b> shipments to <b>Packed</b>. This action cannot be <b>undone</b>. <br />Are you sure you want to proceed?
          </Text>
          <ActionsBar>
            <Button
              onClick={() => onConfirm()}
              fill='full'
              colorVariant='warning'
            >
              Proceed anyway
            </Button>
            <Button
              onClick={() => onClose()}
              colorVariant='brand'
            >
              Cancel
            </Button>
          </ActionsBar>
        </div>
      )}
    </Modal>
  )
}

export default PackDeliveryModal
